// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Debug: Log all environment variables starting with REACT_APP
console.log("🔍 DEBUG: Environment Variables Check");
Object.keys(process.env).forEach(key => {
    if (key.startsWith('REACT_APP_')) {
        console.log(`${key}: ${key.includes('KEY') ? '[HIDDEN]' : process.env[key]}`);
    }
});

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: process.env.REACT_APP_API_KEY,
    authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_APP_ID,
    measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

// Debug: Detailed Firebase config check
console.log("🔍 DEBUG: Firebase Configuration Check");
console.log("API Key status:", {
    defined: !!firebaseConfig.apiKey,
    length: firebaseConfig.apiKey?.length || 0,
    firstChars: firebaseConfig.apiKey ? `${firebaseConfig.apiKey.substring(0, 10)}...` : 'undefined',
    format: firebaseConfig.apiKey?.startsWith('AIza') ? 'valid prefix' : 'invalid prefix'
});

console.log("Firebase config details:", {
    authDomain: {
        value: firebaseConfig.authDomain,
        format: firebaseConfig.authDomain?.includes('firebaseapp.com') ? 'valid format' : 'invalid format'
    },
    projectId: {
        value: firebaseConfig.projectId,
        matches: firebaseConfig.projectId === 'axiasynergy-test' ? 'matches expected' : 'does not match'
    },
    storageBucket: {
        value: firebaseConfig.storageBucket,
        format: firebaseConfig.storageBucket?.includes('firebasestorage.app') ? 'valid format' : 'invalid format'
    },
    messagingSenderId: {
        defined: !!firebaseConfig.messagingSenderId,
        length: firebaseConfig.messagingSenderId?.length || 0
    },
    appId: {
        defined: !!firebaseConfig.appId,
        format: firebaseConfig.appId?.includes(':') ? 'valid format' : 'invalid format'
    }
});

// Initialize Firebase services
let app, db, auth, storage;

try {
    console.log("🔍 DEBUG: Attempting Firebase initialization...");
    app = initializeApp(firebaseConfig);
    console.log("✅ Firebase app initialized successfully");
    
    db = getFirestore(app);
    console.log("✅ Firestore initialized");
    
    auth = getAuth(app);
    console.log("✅ Authentication initialized");
    
    storage = getStorage(app);
    console.log("✅ Storage initialized");
} catch (error) {
    console.error("❌ ERROR: Firebase initialization failed", {
        errorCode: error.code,
        errorMessage: error.message,
        errorStack: error.stack
    });
    throw error; // Re-throw to ensure the error is not silently caught
}

// Export initialized services
export { app, db, auth, storage, firebaseConfig as debugFirebaseConfig };